/* Velvane — capa de movimiento e interacción de la demo «premium» (portada y ficha).
   Réplica de Velvane_premium (2).html adaptada a Shopify:
   - Todo es mejora progresiva: textos, fotos y precios se ven sin este script.
   - Duraciones de 200–400 ms, curvas de salida sin rebote.
   - Con prefers-reduced-motion no hay desplazamientos, parallax ni recuentos:
     todo queda en su estado final y visible.
   - Solo se anima lo que está por debajo de la primera pantalla al cargar. */
(function () {
  'use strict';

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var EASE = 'cubic-bezier(.2,.65,.3,1)';
  function reduced() { return reducedQuery.matches; }
  function clamp(v, a, b) { if (a === undefined) a = 0; if (b === undefined) b = 1; return Math.min(b, Math.max(a, v)); }
  function pad(n) { return String(n).padStart(2, '0'); }
  function headerH() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vv-header-h')) || 88;
  }
  function $$(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var motionImages = [];
  var motionTitles = [];
  var motionStats = [];
  var magnets = [];
  var rails = [];
  var frame = 0;

  /* ---------- Títulos por palabras ---------- */
  function splitTitle(title, instant) {
    if (title.dataset.vpTitle) return;
    title.dataset.vpTitle = 'true';
    title.classList.add('vp-motion-title');
    var nodes = [];
    var walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var n = 0;
    nodes.forEach(function (node) {
      var f = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (w) {
        if (!w.trim()) { f.append(document.createTextNode(w)); return; }
        var span = document.createElement('span');
        span.className = 'vp-motion-word';
        span.textContent = w;
        span.dataset.word = w;
        span.style.setProperty('--word-delay', Math.min(n++ * 25, 100) + 'ms');
        f.append(span);
      });
      node.replaceWith(f);
    });
    if (instant) title.classList.add('vp-instant', 'is-revealed');
  }

  /* ---------- Fotos que se descubren con el scroll ---------- */
  function wrapImage(im, i) {
    if (!im || im.parentElement.classList.contains('vp-motion-image')) return;
    var wrap = document.createElement('div');
    wrap.className = 'vp-motion-image' + (i % 2 ? ' mask-center' : '');
    im.before(wrap);
    wrap.append(im);
    var clone = im.cloneNode();
    clone.removeAttribute('fetchpriority');
    clone.className = 'vp-image-reveal';
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    wrap.append(clone);
  }

  function setupMotion(scope) {
    scope = scope || document;
    var vh = window.innerHeight;

    $$(scope, '.vp h1, .vp h2, .vp .vp-story-caption h3, .vp .vp-ritual-panel h3').forEach(function (title) {
      var r = title.getBoundingClientRect();
      splitTitle(title, reduced() || r.top < vh);
    });

    $$(scope, '.vp .vp-hero-art > img.vp-main-photo, .vp .vp-story > img, .vp .vp-gallery-image > button > img').forEach(wrapImage);

    $$(scope, '.vp .vp-btn').forEach(function (b) {
      if (b.dataset.vpMagnetic) return;
      b.dataset.vpMagnetic = 'true';
      b.classList.add('magnetic');
      b.addEventListener('pointerleave', function () { resetMagnet(b); });
    });

    $$(scope, '.vp .vp-motion-stats [data-count]').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) el.dataset.counted = 'true';
    });

    motionImages = $$(document, '.vp .vp-motion-image');
    motionTitles = $$(document, '.vp .vp-motion-title:not(.is-revealed)');
    motionStats = $$(document, '.vp [data-count]:not([data-counted])');
    magnets = $$(document, '.vp .vp-btn.magnetic');
    rails = $$(document, '[data-vp-rail]');
    requestMotion();
  }

  function resetMagnet(b) {
    b.style.setProperty('--magnet-x', '0px');
    b.style.setProperty('--magnet-y', '0px');
  }
  document.addEventListener('pointermove', function (e) {
    if (reduced() || !pointerQuery.matches) return;
    magnets.forEach(function (b) {
      if (b.disabled || !b.getClientRects().length) return;
      var r = b.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2);
      var dy = e.clientY - (r.top + r.height / 2);
      if (Math.abs(dx) < r.width / 2 + 25 && Math.abs(dy) < r.height / 2 + 25) {
        b.style.setProperty('--magnet-x', clamp(dx * 0.095, -9, 9) + 'px');
        b.style.setProperty('--magnet-y', clamp(dy * 0.17, -6, 6) + 'px');
        b.style.setProperty('--shine-x', ((e.clientX - r.left) / r.width * 100) + '%');
        b.style.setProperty('--shine-y', ((e.clientY - r.top) / r.height * 100) + '%');
      } else {
        resetMagnet(b);
      }
    });
  }, { passive: true });

  function animateCount(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = 'true';
    var end = Number(el.dataset.count);
    if (reduced() || !end) return;
    var start = performance.now();
    function step(now) {
      var t = clamp((now - start) / 350);
      el.textContent = Math.round(end * (1 - Math.pow(1 - t, 3)));
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = end;
    }
    requestAnimationFrame(step);
  }

  function requestMotion() { if (!frame) frame = requestAnimationFrame(updateMotion); }

  function updateMotion() {
    frame = 0;
    var vh = window.innerHeight;
    var still = reduced();
    var root = document.documentElement;
    root.style.setProperty('--page-progress', clamp(window.scrollY / ((root.scrollHeight - vh) || 1)));
    var shell = document.querySelector('[data-vv-nav-shell]');
    if (shell) shell.classList.toggle('is-scrolled', window.scrollY > 30);

    motionTitles.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.96 && r.bottom > 0) el.classList.add('is-revealed');
    });

    motionImages.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = still ? 1 : clamp((vh - r.top) / (Math.min(r.height, vh) * 0.75));
      el.style.setProperty('--reveal', (100 - p * 100) + '%');
      el.style.setProperty('--edge-opacity', p > 0 && p < 1 ? '.65' : '0');
      el.style.setProperty('--image-y', still ? '0px' : clamp((vh / 2 - r.top - r.height / 2) * 0.035, -9, 9) + 'px');
    });

    motionStats.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) animateCount(el);
    });

    $$(document, '.vp .vp-watermark').forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      el.style.setProperty('--watermark-x', still ? '0px' : clamp((vh / 2 - r.top) * 0.075, -55, 55) + 'px');
      el.style.setProperty('--watermark-y', still ? '0px' : clamp((vh / 2 - r.top) * 0.045, -25, 25) + 'px');
    });

    var card = document.querySelector('.vp .vp-floating-card');
    if (card) card.style.setProperty('--float-y', still ? '0px' : clamp(-window.scrollY * 0.09, -35, 0) + 'px');

    var second = document.querySelector('.vp .vp-story.second');
    if (second) {
      var sr = second.getBoundingClientRect();
      second.style.setProperty('--story-y', still ? '0px' : clamp((vh * 0.6 - sr.top) * -0.045, -28, 28) + 'px');
    }

    var selection = document.querySelector('.vp .vp-selection');
    if (selection) {
      var selr = selection.getBoundingClientRect();
      selection.style.setProperty('--section-radius', still ? '0px' : clamp(selr.top / vh, 0, 1) * (window.innerWidth < 681 ? 25 : 50) + 'px');
    }

    rails.forEach(updateRail);
    updateSticky();
  }

  /* ---------- Carril horizontal «El ritual» ---------- */
  function updateRail(rail) {
    var pin = rail.querySelector('.vp-ritual-pin');
    var win = rail.querySelector('.vp-ritual-window');
    var track = rail.querySelector('.vp-ritual-track');
    var pos = rail.querySelector('.vp-rail-position');
    if (!pin || !win || !track) return;
    var total = Number(pos && pos.dataset.total) || rail.querySelectorAll('.vp-ritual-panel').length || 1;
    /* Las fotos de los paneles fuera de pantalla (en horizontal) se piden antes de llegar,
       para que no aparezcan vacías al desplazarse el carril. */
    if (!rail.dataset.vpEager && rail.getBoundingClientRect().top < window.innerHeight * 2) {
      rail.dataset.vpEager = 'true';
      $$(rail, 'img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    var p;
    if (window.innerWidth > 680 && !reduced()) {
      var r = rail.getBoundingClientRect();
      var distance = rail.offsetHeight - pin.offsetHeight;
      p = clamp((headerH() - r.top) / (distance || 1));
      var max = Math.max(0, track.scrollWidth - window.innerWidth);
      track.style.setProperty('--rail-x', (-max * p) + 'px');
      $$(rail, '.vp-ritual-panel').forEach(function (el) {
        var pr = el.getBoundingClientRect();
        el.style.setProperty('--panel-x', clamp((window.innerWidth / 2 - pr.left - pr.width / 2) * 0.035, -28, 28) + 'px');
      });
    } else {
      track.style.setProperty('--rail-x', '0px');
      p = clamp(win.scrollLeft / ((win.scrollWidth - win.clientWidth) || 1));
    }
    rail.style.setProperty('--rail-progress', Math.max(0.03, p));
    if (pos) pos.textContent = pad(Math.min(total, Math.round(p * (total - 1)) + 1)) + ' — ' + pad(total);
  }

  /* ---------- Barra de compra flotante ---------- */
  function updateSticky() {
    $$(document, '[data-vp-sticky]').forEach(function (bar) {
      var scope = bar.closest('product-component') || document;
      var buy = scope.querySelector('[data-vp-main-buy]');
      var show = !!buy && buy.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('visible') === show) return;
      bar.classList.toggle('visible', show);
      bar.inert = !show;
    });
  }

  /* ---------- Galería de la ficha ---------- */
  function initGallery(g) {
    if (g.dataset.vpReady) return;
    g.dataset.vpReady = 'true';
    var main = g.querySelector('.vp-main-photo');
    var thumbs = $$(g, '.vp-thumbnails button');
    var caption = g.querySelector('[data-vp-caption]');
    var counter = g.querySelector('[data-vp-counter]');
    var dialog = g.querySelector('.vp-zoom-dialog');
    var current = 0;

    function select(i) {
      var b = thumbs[i];
      if (!b || !main) return;
      current = i;
      if (b.dataset.srcset) main.srcset = b.dataset.srcset;
      main.src = b.dataset.src;
      main.alt = b.dataset.alt || b.dataset.caption || '';
      if (caption) caption.textContent = b.dataset.caption || '';
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(thumbs.length);
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(i === j)); });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });

    if (main) {
      new MutationObserver(function () {
        var clone = main.parentElement.querySelector('.vp-image-reveal');
        if (!clone || clone.src === main.src) return;
        if (main.srcset) clone.srcset = main.srcset;
        clone.src = main.src;
        if (!reduced()) {
          clone.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 350, easing: EASE });
        }
      }).observe(main, { attributes: true, attributeFilter: ['src'] });
    }

    var zoom = g.querySelector('[data-vp-zoom]');
    if (zoom && dialog && dialog.showModal) {
      var img = dialog.querySelector('img');
      zoom.addEventListener('click', function () {
        var large = thumbs[current] ? thumbs[current].dataset.src : (main.currentSrc || main.src);
        img.src = large;
        img.alt = main.alt;
        dialog.showModal();
      });
      dialog.querySelector('[data-vp-zoom-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) {
        if (e.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
    }
  }

  /* ---------- Selector de packs (variantes) ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.vp-pack-input');
    if (!input || !input.checked) return;
    var scope = input.closest('product-component') || document;
    var idField = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (idField) idField.value = input.value;
    $$(scope, '[data-vp-price]').forEach(function (el) { el.textContent = input.dataset.price; });
    $$(scope, '[data-vp-sticky-price]').forEach(function (el) { el.textContent = input.dataset.price; });
    $$(scope, '.vp-price-line del').forEach(function (el) { el.hidden = !input.dataset.compare; });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    } catch (err) { /* sin historial: no pasa nada */ }
    if (input.dataset.mediaId) {
      var thumb = scope.querySelector('.vp-thumbnails button[data-media-id="' + input.dataset.mediaId + '"]');
      if (thumb) thumb.click();
    }
  });

  /* ---------- Cantidad (+/−) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vp-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 20;
    input.value = Math.max(min, Math.min(max, (parseInt(input.value, 10) || min) + parseInt(btn.dataset.vpQty, 10)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Opiniones: carrusel con jerarquía, inclinación y estrellas ---------- */
  var reviewObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var car = entry.target;
      var st = car._vp;
      if (!entry.isIntersecting || !st || st.seen) return;
      st.seen = true;
      $$(car, '.vp-review-card.prev, .vp-review-card.active, .vp-review-card.next').forEach(function (card) {
        enterCard(card, card.classList.contains('prev') ? -1 : 1, true);
      });
      countUp(car);
    });
  }, { threshold: 0.22 }) : null;

  function clearTilt(surface) {
    surface.style.setProperty('--tilt-x', '0deg');
    surface.style.setProperty('--tilt-y', '0deg');
  }

  function lightStars(card, animate) {
    card.classList.add('vp-lit');
    $$(card, '.vp-star-light').forEach(function (light, i) {
      light.getAnimations().forEach(function (a) { a.cancel(); });
      if (!animate || reduced()) return;
      light.animate([
        { opacity: 0.05, transform: 'scale(.75)', filter: 'drop-shadow(0 0 0px #a3845000)' },
        { opacity: 1, transform: 'scale(1)', filter: 'drop-shadow(0 0 3px #c3a16466)' }
      ], { duration: 210, delay: i * 35, easing: 'ease-out', fill: 'backwards' });
    });
  }

  function enterCard(card, side, initial) {
    var surface = card.querySelector('.vp-review-surface');
    if (!surface) return;
    surface.getAnimations().forEach(function (a) { a.cancel(); });
    clearTilt(surface);
    if (!reduced()) {
      side = side || 1;
      surface.animate([
        { transform: 'perspective(1000px) translateX(' + side * (initial ? 75 : 40) + 'px) translateY(' + (initial ? 16 : 6) + 'px) rotateZ(' + side * 4 + 'deg) rotateY(' + side * 3 + 'deg)' },
        { transform: 'perspective(1000px) translateX(0) translateY(0) rotateZ(0deg) rotateY(0deg)' }
      ], { duration: 380, easing: EASE });
    }
    lightStars(card, true);
  }

  function countUp(car) {
    var st = car._vp;
    var counter = car.querySelector('.vp-counter');
    if (!counter || reduced()) return;
    var current = st.index + 1;
    var end = st.count;
    var start = performance.now();
    var token = {};
    counter._token = token;
    function tick(now) {
      if (counter._token !== token) return;
      var t = Math.min(1, (now - start) / 350);
      counter.textContent = pad(current) + ' / ' + (t < 1 ? Math.round(end * (1 - Math.pow(1 - t, 3))) : end);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function sizeStage(car) {
    var stage = car.querySelector('.vp-review-stage');
    var surfaces = $$(car, '.vp-review-surface');
    if (!stage || !surfaces.length) return;
    surfaces.forEach(function (s) { s.style.minHeight = ''; });
    var max = 0;
    surfaces.forEach(function (s) { max = Math.max(max, s.offsetHeight); });
    surfaces.forEach(function (s) { s.style.minHeight = max + 'px'; });
    $$(car, '.vp-review-card').forEach(function (c) { c.style.minHeight = max + 'px'; });
    stage.style.height = (max + 69) + 'px';
  }

  function initCarousel(car) {
    if (car.dataset.vpReady) return;
    car.dataset.vpReady = 'true';
    var cards = $$(car, '.vp-review-card');
    var count = cards.length;
    if (!count) return;
    var counter = car.querySelector('.vp-counter');
    var dots = $$(car, '.vp-dots button');
    var st = { index: 0, count: count, seen: false };
    car._vp = st;

    function set(i) {
      var previous = st.index;
      st.index = (i + count) % count;
      cards.forEach(function (el, j) {
        var d = (j - st.index + count) % count;
        el.classList.remove('active', 'next', 'prev');
        if (d === 0) el.classList.add('active');
        else if (d === 1) el.classList.add('next');
        else if (d === count - 1) el.classList.add('prev');
        el.setAttribute('aria-hidden', d !== 0 ? 'true' : 'false');
      });
      dots.forEach(function (b, j) { b.setAttribute('aria-current', String(j === st.index)); });
      if (counter) {
        counter._token = null;
        counter.textContent = pad(st.index + 1) + ' / ' + count;
      }
      $$(car, '.vp-review-card:not(.active) .vp-review-surface').forEach(clearTilt);
      if (!st.seen || previous === st.index) return;
      var forward = (st.index - previous + count) % count <= count / 2;
      enterCard(car.querySelector('.vp-review-card.active'), forward ? 1 : -1);
      $$(car, '.vp-review-card.prev, .vp-review-card.next').forEach(function (c) { lightStars(c, false); });
    }
    function move(d) { set(st.index + d); }

    $$(car, '[data-vp-review-step]').forEach(function (b) {
      b.addEventListener('click', function () { move(parseInt(b.dataset.vpReviewStep, 10)); });
    });
    dots.forEach(function (b) {
      b.addEventListener('click', function () { set(parseInt(b.dataset.vpReviewGo, 10)); });
    });
    car.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      move(e.key === 'ArrowRight' ? 1 : -1);
    });

    /* Arrastrar / deslizar / rueda horizontal: un gesto avanza una opinión. */
    var start = null;
    var dx = 0;
    var wheel = 0;
    var last = 0;
    function endDrag() {
      start = null;
      car.classList.remove('dragging');
      car.style.setProperty('--drag-x', '0px');
    }
    car.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button') || e.button !== 0) return;
      start = e.clientX;
      dx = 0;
      car.classList.add('dragging');
      try { car.setPointerCapture(e.pointerId); } catch (err) {}
    });
    car.addEventListener('pointermove', function (e) {
      if (start === null) return;
      dx = e.clientX - start;
      car.style.setProperty('--drag-x', clamp(dx, -120, 120) + 'px');
    });
    car.addEventListener('pointerup', function () {
      if (start === null) return;
      if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1);
      endDrag();
    });
    car.addEventListener('pointercancel', endDrag);
    car.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 2) return;
      e.preventDefault();
      var now = performance.now();
      if (now - last < 350) return;
      wheel += e.deltaX;
      if (Math.abs(wheel) > 40) {
        move(wheel > 0 ? 1 : -1);
        last = now;
        wheel = 0;
      }
    }, { passive: false });

    /* Inclinación suave y brillo que sigue al cursor (solo ratón). */
    cards.forEach(function (card) {
      var surface = card.querySelector('.vp-review-surface');
      if (!surface) return;
      card.addEventListener('pointermove', function (e) {
        if (reduced() || !pointerQuery.matches || e.pointerType === 'touch' || car.classList.contains('dragging')) return;
        var r = card.getBoundingClientRect();
        var x = clamp((e.clientX - r.left) / r.width * 2 - 1, -1, 1);
        var y = clamp((e.clientY - r.top) / r.height * 2 - 1, -1, 1);
        surface.style.setProperty('--tilt-x', (-y * 3.5).toFixed(2) + 'deg');
        surface.style.setProperty('--tilt-y', (x * 4).toFixed(2) + 'deg');
        surface.style.setProperty('--review-light-x', (x + 1) * 50 + '%');
        surface.style.setProperty('--review-light-y', (y + 1) * 50 + '%');
      });
      card.addEventListener('pointerleave', function () { clearTilt(surface); });
      card.addEventListener('pointerdown', function () { clearTilt(surface); });
    });

    sizeStage(car);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { sizeStage(car); });

    if (reduced() || !reviewObserver) {
      st.seen = true;
      cards.forEach(function (c) { lightStars(c, false); });
    } else {
      car.classList.add('vp-stars-pending');
      reviewObserver.observe(car);
    }
  }

  /* ---------- Arranque ---------- */
  var progress = document.createElement('i');
  progress.className = 'vp-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');

  function init(scope) {
    $$(scope, '[data-vp-gallery]').forEach(initGallery);
    $$(scope, '[data-vp-reviews] .vp-carousel').forEach(initCarousel);
    setupMotion(scope);
    $$(scope, '[data-vp-rail] .vp-ritual-window').forEach(function (win) {
      if (win.dataset.vpReady) return;
      win.dataset.vpReady = 'true';
      win.addEventListener('scroll', requestMotion, { passive: true });
    });
  }

  function start() {
    if (document.querySelector('.vp')) document.body.append(progress);
    init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('scroll', requestMotion, { passive: true });
  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    requestMotion();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { $$(document, '[data-vp-reviews] .vp-carousel').forEach(sizeStage); }, 150);
  });
  document.addEventListener('load', requestMotion, true);
  reducedQuery.addEventListener('change', function () {
    magnets.forEach(resetMagnet);
    $$(document, '.vp .vp-review-surface').forEach(function (el) {
      el.getAnimations().forEach(function (a) { a.cancel(); });
      clearTilt(el);
    });
    requestMotion();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Carga diferida real de las fotos de más abajo (snippets/vp-defer-img.liquid).
   Chrome precarga las imágenes loading="lazy" que están a ~1250–2500 px del viewport cuando la
   conexión es lenta; aquí no se pide ninguna hasta que el usuario está a ~500 px. */
(function () {
  'use strict';
  function reveal(img) {
    if (!img.hasAttribute('data-vp-defer')) return;
    var sz = img.getAttribute('data-sizes'), ss = img.getAttribute('data-srcset'), s = img.getAttribute('data-src');
    if (sz) img.sizes = sz;
    if (ss) img.srcset = ss;
    if (s) img.src = s;
    img.removeAttribute('data-vp-defer');
  }
  function setup(scope) {
    var imgs = Array.prototype.slice.call((scope || document).querySelectorAll('img[data-vp-defer]'));
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.target.matches('img')) { reveal(e.target); return; }
        Array.prototype.forEach.call(e.target.querySelectorAll('img[data-vp-defer]'), reveal);
      });
    }, { rootMargin: '500px 0px' });
    var seen = [];
    imgs.forEach(function (img) {
      /* El carril horizontal del ritual: se piden todas sus fotos a la vez al acercarse a la sección. */
      var t = img.closest('.vp-ritual-scroll') || img;
      if (seen.indexOf(t) === -1) { seen.push(t); io.observe(t); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
